<script>
export default {
  name: "Comment",
  props: {
    commentObj: Object
  },
}
</script>

<template>
<Card class="m-1" :pt="{body: 'p-2'}">
  <template #content>
    <h6>{{ commentObj.user.display_name }}</h6>
    <p>{{ commentObj.comment }}</p>
  </template>
</Card>
</template>

<style scoped>

</style>